import { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { X, ChevronLeft, ChevronRight } from "lucide-react";
import axios from "axios";

const API = process.env.REACT_APP_BACKEND_URL;

const defaultItems = [
  { image: "https://images.unsplash.com/photo-1757924432508-d4e92411caeb?w=600&q=80", title: "Konut Projeleri" },
  { image: "https://images.pexels.com/photos/4458205/pexels-photo-4458205.jpeg?auto=compress&cs=tinysrgb&w=600", title: "Altyapı" },
  { image: "https://images.unsplash.com/photo-1664902578190-ec984429fabc?w=600&q=80", title: "Ticari Yapılar" },
  { image: "https://images.unsplash.com/photo-1772090131833-f7db87feab28?w=600&q=80", title: "Endüstriyel" },
];

export default function Gallery() {
  const [items, setItems] = useState(defaultItems);
  const [lightboxIndex, setLightboxIndex] = useState(null);

  useEffect(() => {
    axios.get(`${API}/api/gallery`).then((r) => {
      if (r.data.length > 0) setItems(r.data);
    }).catch(() => {});
  }, []);

  const openLightbox = (i) => setLightboxIndex(i);
  const closeLightbox = () => setLightboxIndex(null);
  const prevImage = () => setLightboxIndex((p) => (p - 1 + items.length) % items.length);
  const nextImage = () => setLightboxIndex((p) => (p + 1) % items.length);

  return (
    <section data-testid="gallery-section" className="py-20 sm:py-28 px-5 sm:px-8 lg:px-12 max-w-7xl mx-auto">
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
        {items.map((item, i) => (
          <motion.div
            key={item.id || i}
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: i * 0.1, duration: 0.6 }}
            className="gallery-card aspect-square rounded-2xl"
            data-testid={`gallery-item-${i}`}
            onClick={() => openLightbox(i)}
          >
            <img src={item.image} alt={item.title} loading="lazy" className="rounded-2xl" />
            <div className="overlay rounded-2xl flex flex-col justify-end p-6">
              <p className="text-white font-bold text-lg" style={{ fontFamily: "Outfit" }}>{item.title}</p>
            </div>
          </motion.div>
        ))}
      </div>

      {/* Lightbox */}
      <AnimatePresence>
        {lightboxIndex !== null && (
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            className="fixed inset-0 bg-black/90 z-[100] flex items-center justify-center p-4"
            onClick={closeLightbox}
            data-testid="gallery-lightbox"
          >
            <button className="absolute top-4 right-4 text-white/60 hover:text-white z-10 transition-colors" onClick={closeLightbox} data-testid="gallery-lightbox-close">
              <X size={28} />
            </button>
            {items.length > 1 && (
              <>
                <button onClick={(e) => { e.stopPropagation(); prevImage(); }} className="absolute left-4 top-1/2 -translate-y-1/2 w-12 h-12 bg-white/10 hover:bg-white/20 text-white rounded-full flex items-center justify-center z-10 transition-colors" data-testid="gallery-lightbox-prev">
                  <ChevronLeft size={24} />
                </button>
                <button onClick={(e) => { e.stopPropagation(); nextImage(); }} className="absolute right-4 top-1/2 -translate-y-1/2 w-12 h-12 bg-white/10 hover:bg-white/20 text-white rounded-full flex items-center justify-center z-10 transition-colors" data-testid="gallery-lightbox-next">
                  <ChevronRight size={24} />
                </button>
              </>
            )}
            <div className="text-center" onClick={(e) => e.stopPropagation()}>
              <motion.img
                key={lightboxIndex}
                initial={{ opacity: 0, scale: 0.9 }}
                animate={{ opacity: 1, scale: 1 }}
                transition={{ duration: 0.3 }}
                src={items[lightboxIndex].image}
                alt={items[lightboxIndex].title}
                className="max-w-[90vw] max-h-[80vh] object-contain rounded-lg"
              />
              <p className="text-white/80 text-lg font-semibold mt-4" style={{ fontFamily: "Outfit" }}>{items[lightboxIndex].title}</p>
              <p className="text-white/40 text-sm mt-1">{lightboxIndex + 1} / {items.length}</p>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </section>
  );
}
